import { render, staticRenderFns } from "./BasMaterialCategoryList.vue?vue&type=template&id=cbcea9c6&scoped=true&"
import script from "./BasMaterialCategoryList.vue?vue&type=script&lang=js&"
export * from "./BasMaterialCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./BasMaterialCategoryList.vue?vue&type=style&index=0&id=cbcea9c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcea9c6",
  null
  
)

export default component.exports